module.exports = __webpack_public_path__ + "static/media/WireRope3.9ef972f6.webp";